const classes = (...classNames) =>
  classNames.filter((item) => typeof item === "string").join(" ");

export default classes;
